export const titlecase = (string: string): string => {
  return string.charAt(0).toLocaleUpperCase() + string.slice(1);
};
